import {
    ableProps,
    ablePropsInit,
    events as baseEvents,
} from '../component-base/props';

export const props = () => [
    ...ableProps,
    {
        key: 'text',
        label: '文本节点文字',
        type: 'string',
    },
    {
        key: 'attrs',
        label: '元素属性',
        type: 'object',
    },
];

export const init = () => ({
    ...ablePropsInit,
    text: '',
    attrs: {},
});

export const name = '文本节点';

export const component = 'mobile-general-form-node-text';

export const events = [
    ...baseEvents,
];
